import React from 'react';
import { useHistory } from 'react-router-dom';

import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import Icon from '@visa/vds/icon';

import { AdminRoutes } from '../../../../_constants/PageRoutes';

import MCSPagedTable from '../../../../components/MCSPagedTable';
import { useAuthContextUser } from 'context/AuthContext';
function EventTable(props) {
    const user = useAuthContextUser();

    const history = useHistory();
    const manageEvent = (emailEvent) => {
        history.push({
            pathname: AdminRoutes.EMAILNOTIFICATION_SETTINGS,
            state: {
                emailEvent: emailEvent
            }
        })
    }

    const { events } = props
    
    const colHeaders = [
        { displayName: "Description Text", name: "name" },
        { displayName: "Email Notification User Group", name: "userGroupName" },
        { displayName: "Email Type", name: "emailType" },
        ...(user.isSuperAdmin ? [{ displayName: "Action", name: "action" }] : []),
    ];

    return (
        <>
            <MCSPagedTable size={"compact"}
                colHeaders={colHeaders}
                useSearchBar={false}
                usePagination={false}
                tableData={
                    events && events.map((row, key) => (
                        <Tr key={key}>
                            <Td>{row.name}</Td>
                            <Td>{row.userGroupName}</Td>
                            <Td>{row.emailTypeName}</Td>
                            {user.isSuperAdmin &&
                                <Td>
                                    <Icon className="vss-clickable-icon" name="settings" resolution="low" onClick={() => manageEvent(row)} />
                                </Td>
                            }
                        </Tr>
                    ))
                }
            />
        </>
    )


}

export default EventTable;